import { observer } from "mobx-react-lite";
import * as React from "react";
import { ModalPlm } from "src/components/ModalPlm";
import { Form, Input } from "antd";
import { trimRequired } from "src/common/validationRules/trimRequired";
import { bom3ControlStore as store } from "./Bom3ControlStore";

export const Bom3Modal: React.FC = observer(() => {
  const [form] = Form.useForm();
  const { currentRow } = store;
  React.useEffect(() => {
    form.resetFields();
    if (currentRow) form.setFieldsValue(currentRow);
  }, [currentRow]);

  return (
    <ModalPlm
      open={!!currentRow}
      onCancel={() => store.closeCreate()}
      onOk={() => form.submit()}
      okButtonProps={{ loading: store.task === "create" }}
      okText="Сохранить"
      title="Новый экземпляр объекта BOM"
      width={750}
      maskClosable={false}
      centered
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={(values) => store.apply(values)}
      >
        <Form.Item name="name" label="Название" rules={[trimRequired()]}>
          <Input allowClear />
        </Form.Item>
      </Form>
    </ModalPlm>
  );
});
